import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContestDetailRequest } from "providers/ContestProvider/slice";
import { Row, Typography, Card, Descriptions, Tag, Spin, Col, Divider, Modal } from "antd";

const imageBoxStyle = {
  border: "1px solid #f0f0f0",
  borderRadius: 8,
  padding: 8,
  background: "#fafafa",
  textAlign: "center",
  marginBottom: 16,
};

// Utility to strip HTML tags
const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>?/gm, "").replace(/&nbsp;/g, ' ');
};

const ContestDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const contestDetail = useSelector((state) => state.contestSlice.contestDetail);
  const isLoading = useSelector((state) => state.contestSlice.isLoading);

  // For image preview modal
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  useEffect(() => {
    if (id) dispatch(getContestDetailRequest(id));
  }, [id, dispatch]);

  const handlePreview = (imgUrl, title) => {
    setPreviewImage(imgUrl);
    setPreviewTitle(title);
    setPreviewVisible(true);
  };

  if (isLoading || !contestDetail) {
    return (
      <div style={{ textAlign: "center", padding: 40 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="contest-detail-wrapper">
      <Row className="contest-detail-header" justify="start" align="middle">
        <Typography.Title level={4}>Chi tiết cuộc thi</Typography.Title>
      </Row>
      <Card style={{ marginTop: 24, marginBottom: 24 }}>
        <Row gutter={[32, 32]}>
          {/* Banner and Logo */}
          <Col xs={24} md={12}>
            <div style={imageBoxStyle}>
              <Typography.Text strong>Banner cuộc thi</Typography.Text>
              <div style={{ marginTop: 8 }}>
                {contestDetail.bannerImage ? (
                  <img
                    src={contestDetail.bannerImage}
                    alt="Banner"
                    style={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 8, cursor: "pointer" }}
                    onClick={() => handlePreview(contestDetail.bannerImage, "Banner cuộc thi")}
                  />
                ) : (
                  <div style={{ color: "#bbb" }}>Không có banner</div>
                )}
              </div>
            </div>
            <div style={imageBoxStyle}>
              <Typography.Text strong>Logo cuộc thi</Typography.Text>
              <div style={{ marginTop: 8 }}>
                {contestDetail.logoContest ? (
                  <img
                    src={contestDetail.logoContest}
                    alt="Logo"
                    style={{ width: 120, height: 120, objectFit: "contain", borderRadius: 8, background: "#fff", cursor: "pointer" }}
                    onClick={() => handlePreview(contestDetail.logoContest, "Logo cuộc thi")}
                  />
                ) : (
                  <div style={{ color: "#bbb" }}>Không có logo</div>
                )}
              </div>
            </div>
          </Col>
          {/* Timeline and Route Banner */}
          <Col xs={24} md={12}>
            <div style={imageBoxStyle}>
              <Typography.Text strong>Timeline cuộc thi</Typography.Text>
              <div style={{ marginTop: 8 }}>
                {contestDetail.timelineContest ? (
                  <img
                    src={contestDetail.timelineContest}
                    alt="Timeline"
                    style={{ width: "100%", maxHeight: 180, objectFit: "cover", borderRadius: 8, cursor: "pointer" }}
                    onClick={() => handlePreview(contestDetail.timelineContest, "Timeline cuộc thi")}
                  />
                ) : (
                  <div style={{ color: "#bbb" }}>Không có timeline</div>
                )}
              </div>
            </div>
            <div style={imageBoxStyle}>
              <Typography.Text strong>Banner lộ trình</Typography.Text>
              <div style={{ marginTop: 8 }}>
                {contestDetail.routeBanner ? (
                  <img
                    src={contestDetail.routeBanner}
                    alt="Route Banner"
                    style={{ width: "100%", maxHeight: 180, objectFit: "cover", borderRadius: 8, cursor: "pointer" }}
                    onClick={() => handlePreview(contestDetail.routeBanner, "Banner lộ trình")}
                  />
                ) : (
                  <div style={{ color: "#bbb" }}>Không có banner lộ trình</div>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <Divider />
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Tên cuộc thi">
            {contestDetail.name}
          </Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={contestDetail.status === "active" ? "green" : contestDetail.status === "disabled" ? "red" : "orange"}>
              {contestDetail.status}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Ngày bắt đầu">
            {contestDetail.startDate ? new Date(contestDetail.startDate).toLocaleDateString() : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày kết thúc">
            {contestDetail.endDate ? new Date(contestDetail.endDate).toLocaleDateString() : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Mô tả">
            {stripHtml(contestDetail.description)}
          </Descriptions.Item>
          <Descriptions.Item label="Quy tắc">
            {stripHtml(contestDetail.rules)}
          </Descriptions.Item>
          <Descriptions.Item label="Tổng số ứng viên">
            {contestDetail.totalCandidates}
          </Descriptions.Item>
          <Descriptions.Item label="Tổng số bình chọn">
            {contestDetail.totalVotes}
          </Descriptions.Item>
          {contestDetail.registerFormLink && (
            <Descriptions.Item label="Link form đăng ký">
              <a href={contestDetail.registerFormLink} target="_blank" rel="noopener noreferrer">
                {contestDetail.registerFormLink}
              </a>
            </Descriptions.Item>
          )}
        </Descriptions>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={() => setPreviewVisible(false)}
          centered
        >
          <img alt={previewTitle} style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </Card>
    </div>
  );
};

export default ContestDetail; 